import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtMessageModule, IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { I18nModule, UrlModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { CustomFacetComponent } from './facet.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

@NgModule({
  imports: [
    AtMessageModule,
    CommonModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
    RouterModule,
    UrlModule,
    ReactiveFormsModule,
    NgxMaskDirective,
  ],
  declarations: [CustomFacetComponent],
  exports: [CustomFacetComponent],
})
export class CustomFacetModule {}
